import React from 'react';
import PropTypes from 'prop-types';

import CoverLink from '../../common/CoverLink';
import ButtonPreview from './ButtonPreview';

function ColumnCover({ width, item, previewPlayer }) {
  const tag = (item.pre_order) ? 'Pre-order' : null;
  return (
    <div style={{ width, zIndex: 50 }}>
      <CoverLink to={`/releases/${item.releaseID}/${item.id}`} alt={`cover${item.id}`} className={`cover-list cover-link preview-image ${(previewPlayer.isPreview && previewPlayer.isPlaying) && `playing` }`} src={item.img} tag={tag} />
      <div className={`oo cover-list`}>
        <ButtonPreview isPlay={previewPlayer.isPreview && previewPlayer.isPlaying} onClick={ (!previewPlayer.isPlaying || !previewPlayer.isPreview) ? previewPlayer.play : previewPlayer.pause } />
      </div>
    </div>
  )
}

ColumnCover.propTypes = {
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  previewPlayer: PropTypes.object.isRequired
}

export default ColumnCover;
